import { apiClient } from '@/shared/api/client';
import type { GenerateRequest, GenerateResponse, Recipe } from '@/shared/types';

export async function generateMixes(request: GenerateRequest): Promise<Recipe[]> {
  const response = await apiClient<GenerateResponse>('/api/mixes/generate', {
    method: 'POST',
    body: request,
  });
  return response.data;
}

export async function generateRandomMixes(request: Omit<GenerateRequest, 'ingredients' | 'constraints'>): Promise<Recipe[]> {
  const response = await apiClient<GenerateResponse>('/api/mixes/random', {
    method: 'POST',
    body: request,
  });
  return response.data;
}
